import './App.css';
import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import logUserAction from "./Logging";


//var selectedCategory = 'NA';
var currentuserid = '';


let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      //selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function navigatetoMyScorePage() {
  logUserAction(currentuserid,'Profile page: clicked my score button on points weightage');
  window.location.href = window.location.pathname + "?pageName=MyScore&userid=" + currentuserid;
  return;
};

function PointsWeightage() { 
  const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // https://kc-service-eight.vercel.app // http://localhost:3000
  const [pointsWeightage, setPointsWeightage] = useState([]);

  useEffect(() => {
    async function fetchAllPointsWeighage() {
      const response = await fetch(KC_SERVICE + '/vouchers_getAllPointsWeightage', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId: currentuserid.split('-')[0] }),
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
      const result = await response.json();
      console.log('Fetched PointsWeightage:', result.PointsWeightage);
      console.log(Array.isArray(result.PointsWeightage));
  
      const weightageData = Array.isArray(result.PointsWeightage) ? result.PointsWeightage : [];
      setPointsWeightage(weightageData);
      console.log('P1ointsWeightage:', weightageData);

      //setLoading(false);
    }
    fetchAllPointsWeighage();
  },[KC_SERVICE] );  

  return (
  <div>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h3 style={{ marginRight: '16px' }}>Points Weightage History</h3>
        <button
          onClick={() => navigatetoMyScorePage()}
          style={{
            padding: '8px 16px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          My Score
        </button>
      </div>
    </div>    
    <div>
    <canvas id="pointsWeightageChart" width="400" height="200"></canvas>
    </div>
    {pointsWeightage.length > 0 ? (
      <LineChart
        width={400}
        height={200}
        data={pointsWeightage.map(item => ({
          ...item,
          created_at: new Date(item.created_at).toLocaleDateString('en-GB'), // Format to 'dd/mm/yyyy'
        }))}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <XAxis dataKey="created_at" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="weightage" stroke="#4bc0c0" />
      </LineChart>
    ) : (
      <p>No data available to display the chart.</p>
    )}
  </div>
  );
}

export default PointsWeightage;